<template>
  <div :style="['z-index: 1', type === 2 ? '' : 'transform: rotate(180deg)']">
    <svg
      class="heading"
      xmlns:svg="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="100%"
      height="100%"
      preserveAspectRatio="none "
      
    >
      <title>{{ hint }}</title>

      <rect
        v-if="type != 2"
        x="0"
        y="0"
        width="100%"
        height="100%"
        fill="#E6E6E6"
        stroke="gray"
        stroke-width="1"
      ></rect>
      <rect
        v-if="type != 2"
        x="0"
        y="0%"
        width="100%"
        :height="(value > 100 ? 100 : value) + '%'"
        :fill="fill"
        stroke="gray"
        stroke-width="1"
      ></rect>
      <rect
        v-if="type == 2"
        x="0"
        y="0"
        width="100%"
        height="100%"
        fill="#E6E6E6"
        stroke="gray"
        stroke-width="1"
      ></rect>
      <rect
        v-if="type == 2"
        x="0"
        y="0%"
        :width="(value > 100 ? 100 : value) + '%'"
        height="100%"
        :fill="fill"
        stroke="gray"
        stroke-width="1"
      ></rect>
    </svg>
  </div>
</template>

<script>
import MixinBase from "./mixin-base.js";

export default {
  name: "progressbar",
  props: {
    type: { type: Number, default: 1 },
    fill: {
      type: String,
      default: "blue",
    },
  },
  mixins: [MixinBase],
  components: {},
  data: () => ({}),
};
</script>
